<template v-if="input">
  <tr @click.stop="toggleDetails">
    <td>
      <transaction-icon :transaction-type="notes.transactionType || ''" />
    </td>
    <td class="text-muted small">{{ input.date.substr(5,10).replace('-','/') }}</td>
    <td class="small">
      <div class="text-wrap-any text-two-line" :title=" input.description.replace(/\W/g,' ') ">{{ input.description }}</div>
      <small class="d-none"><pre class="small">{{input.amount}}</pre></small>
    </td>
    <td class="text-end">
      <strong :class="{'text-success': input.direction === 'DEPOSIT' || input.direction === 'CREDIT', 'text-danger': input.direction === 'WITHDRAWAL'}">
        ${{ input.amount.toFixed(2) }}
      </strong>
    </td>
    <td class="text-end p-1 align-middle" v-if="isManualTransaction">
      <div class="dropdown" @click.stop>
        <button class="btn btn-sm btn-link text-muted p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="bi bi-three-dots-vertical"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end">
          <li>
            <a class="dropdown-item" href="#" @click.prevent="handleEdit">
              <i class="bi bi-pencil me-2"></i>Edit
            </a>
          </li>
          <li><hr class="dropdown-divider"></li>
          <li>
            <a class="dropdown-item text-danger" href="#" @click.prevent="handleDelete">
              <i class="bi bi-trash me-2"></i>Delete
            </a>
          </li>
        </ul>
      </div>
    </td>
    <td class="text-end p-1 align-middle" v-else>
      <!-- Empty cell for system transactions to maintain alignment -->
    </td>
  </tr>

    <app-modal :modal-in="show" @close="show=false">
      <template #header>Order Details {{ orderId }}</template>
      <div class="container">
        <platform-order v-if="orderId" :order-id="orderId" :key="orderId" />
        <map-transaction-to-order v-else :transaction="notes" @on-select-order="attachOrder" />
      </div>
    </app-modal>

    <app-modal :modal-in="showEditModal" @close="showEditModal=false" modal-class="modal-xl">
      <template #header>Edit Transaction</template>
      <edit-transaction :transaction="notes" @saved="handleTransactionSaved" />
    </app-modal>


</template>

<script setup>
  import { defineProps, ref, computed, defineEmits } from 'vue'
  import { useStore } from 'vuex'
  import PlatformOrder from "@/app/components/ebay/PlatformOrder.vue";
  import AppModal from "@/app/components/Utils/AppModal.vue";
  import MapTransactionToOrder from "@/app/components/mapTransactionToOrder.vue";
  import EditTransaction from "@/app/components/transactions/EditTransaction.vue";
  import TransactionIcon from "@/app/components/Utils/TransactionIcon.vue";

  const show = ref(false)
  const showEditModal = ref(false)
  const store = useStore()

  const emit = defineEmits(['updated', 'deleted']);

  const props = defineProps({
    input: {
      type: Object,
      required: true,
      default: () => ({})
    }
  })

  const notes = computed(() => JSON.parse(props.input.notes || '{}'))
  const orderId = computed(() => {
    if (notes.value.orderId) return notes.value.orderId
    if (notes.value.references) {
      const reference = notes.value.references.find(r => r.referenceType === "ORDER_ID")
      if (reference) return reference.referenceId
    }
    return null
  })

  // Check if this is a manual (non-system) transaction
  const isManualTransaction = computed(() => {
    return notes.value.isSystem === 0 || notes.value.isSystem === false
  })

  function toggleDetails() {
    show.value = !show.value
  }

  function handleEdit() {
    showEditModal.value = true
  }

  async function handleDelete() {
    if (!confirm('Are you sure you want to delete this transaction? This action cannot be undone.')) {
      return
    }

    try {
      await store.dispatch('eshop/deleteTransaction', { transactionId: notes.value.transactionId })
      emit('deleted', notes.value.transactionId)
    } catch (error) {
      alert(error.message || error.toString() || 'Failed to delete transaction')
      console.error('Delete transaction error:', error)
    }
  }

  function handleTransactionSaved(result) {
    showEditModal.value = false
    emit('updated', result)
  }

  function attachOrder(o) {
    store.dispatch('eshop/mapTransactionToOrder', {transactionId: notes.value.transactionId, orderId: o.order_id})
        .then(data => console.log(data))
        .catch(e => {
          alert(e.response.data.error || e.message || JSON.stringify(e))
        })
  }

</script>
